import type { ApiOrder } from "@src/api/orders";
import { groupSpMovingsByCell, type SpMoving } from "../../../../../api/storePlaces";

/** Форматирует подпись заказа строки НС. */
export function formatShipmentOrderText(order: ApiOrder | null | undefined): string {
    if (order == null) {
        return "Не задано";
    }

    const shortNum = order.ShortNum.trim();
    if (shortNum !== "") {
        return shortNum;
    }

    const num = order.Num.trim();
    if (num !== "") {
        return num;
    }

    const name = order.Name.trim();
    return name === "" ? "Не задано" : name;
}

/** Форматирует подпись ячейки места хранения. */
export function formatShipmentCellName(cell: { Num: string; SPIndex: string } | undefined): string {
    if (cell == null) {
        return "";
    }

    return cell.SPIndex === "" ? cell.Num : `${cell.Num} - ${cell.SPIndex}`;
}

/**
 * Форматирует ячейки размещения строки НС по движениям `LeaveSdbCode`.
 * @param movements движения `spMoving` строки НС
 */
export function formatShipmentCellsFromSpMovings(movements: SpMoving[] | undefined): string {
    const cells = groupSpMovingsByCell(movements);
    if (cells.length === 0) {
        return "Не задано";
    }

    const cellNames = cells.map((cell) => formatShipmentCellName(cell.StorePlace)).filter((name) => name !== "");
    return cellNames.length === 0 ? "Не задано" : cellNames.join(", ");
}
